import React from 'react';
import { stats } from '../data/landing';
export function StatsBand() {
  return <section aria-labelledby="stats-title" className="border-b border-line bg-white" data-id="element-192" data-mp="21b6867vh5nxz">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:py-14" data-id="element-193" data-mp="219bikg99d7nk">
        <h2 id="stats-title" className="text-center text-[11px] font-bold uppercase tracking-[0.2em] text-coral" data-id="element-194" data-mp="1wcuufm226tah">
          <span aria-hidden="true" data-id="element-195" data-mp="1retcx5ka7214">📊 </span>Las cifras no mienten
        </h2>

        <dl className="mt-9 grid grid-cols-2 gap-y-9 sm:grid-cols-4" data-id="element-196" data-mp="2ozfpoxlnnpjb">
          {stats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-1 px-2 text-center sm:border-r sm:border-line sm:last:border-r-0" data-id="element-197" data-mp="2k2p9ma9uotxw">
              <dd className="font-display text-3xl font-black leading-none text-ink sm:text-4xl" data-id="element-198" data-mp="2f4dzdyfn8hf5">{stat.value}</dd>
              <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-muted" data-id="element-199" data-mp="13ne918cuwcnr">{stat.label}</dt>
            </div>)}
        </dl>
      </div>
    </section>;
}